import { render, staticRenderFns } from "./UpdateManage.vue?vue&type=template&id=0ff2976c"
import script from "./UpdateManage.vue?vue&type=script&lang=js"
export * from "./UpdateManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports